import { useEffect, useState } from 'react';
import { Hero3D } from '../components/Hero3D';
import { HexCoreShowcase } from '../components/HexCoreShowcase';
import { ProFoamShowcase } from '../components/ProFoamShowcase';
import { TechnicalsTeaser } from '../components/TechnicalsTeaser';
import { CompareTeaser } from '../components/ComparePanel';
import { ScrollingTextReveal } from '../components/WowOptions';
import { TechnologySection } from '../components/TechnologySection';
import { ErneTeaser } from '../components/ErneTeaser';
import { JournalFeedSection } from '../components/JournalFeedSection';
import { PartnerGallery } from '../components/PartnerGallery';
import { ContactSection } from '../components/ContactSection';
import { CreditsOption3 } from '../components/CreditsSection';
import { Seo } from '../components/Seo';
import { HomeReviews } from '../components/reviews/PlayerReviews';
import axios from 'axios';
import { CONTACT_FAQS } from '../data/legalContent';

const SITE = 'https://dyssc.com';

export default function Home() {
  const [products, setProducts] = useState([]);
  const [reviewStats, setReviewStats] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then((res) => res.json())
      .then((data) => setProducts(data))
      .catch((err) => console.error('Failed to fetch products:', err));
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/reviews/featured`)
      .then(({ data }) => setReviewStats(data.products || []))
      .catch(() => {});
  }, []);

  const jsonLd = [
    {
      '@context': 'https://schema.org', '@type': 'ItemList',
      itemListElement: (products || []).filter((p) => p.live === true).map((p, i) => ({
        '@type': 'ListItem', position: i + 1, url: `${SITE}/product/${p.slug}`, name: `${p.name} Pickleball Paddle`,
      })),
    },
    // Per-paddle Product schema with real AggregateRating → review stars in search results
    ...(products || []).filter((p) => p.live === true).map((p) => {
      const st = reviewStats.find((r) => r.slug === p.slug);
      return st && st.count > 0 ? {
        '@context': 'https://schema.org', '@type': 'Product',
        name: `${p.name} Pickleball Paddle`, url: `${SITE}/product/${p.slug}`, brand: { '@type': 'Brand', name: 'DYSSC' },
        aggregateRating: { '@type': 'AggregateRating', ratingValue: st.avg, reviewCount: st.count, bestRating: 5, worstRating: 1 },
      } : null;
    }).filter(Boolean),
    {
      '@context': 'https://schema.org', '@type': 'FAQPage',
      mainEntity: CONTACT_FAQS.map((f) => ({
        '@type': 'Question', name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

  return (
    <div data-testid="home-page">
      <Seo
        title="Premium Pickleball Paddles in India | DYSSC – Carbon Fiber"
        description="Shop the DYSSC HexCore Pro — a USAPA-approved carbon fiber pickleball paddle with a 16mm honeycomb core and Toray T700 face, engineered for power, spin and control. Buy online across India."
        canonical={`${SITE}/`}
        jsonLd={jsonLd}
      />
      <Hero3D />
      <HexCoreShowcase />
      <ProFoamShowcase />
      <HomeReviews />
      <TechnicalsTeaser />
      <CompareTeaser />
      <ErneTeaser />
      <ScrollingTextReveal />
      <TechnologySection />
      <JournalFeedSection />
      <PartnerGallery />
      <ContactSection />
      <CreditsOption3 />
    </div>
  );
}
